import React from 'react';
import {num2likestr} from 'util/index';

import ArrowRight from 'components/ArrowRight';
import s from './index.module.scss';

interface Item {
  id: string;
  imgUrl: string;
  browseNum: number;
  likeNum: number;
  title: string;
}

interface Props {
  list: Item[];
  onClickItem: (id: string) => void;
  onClickMore: () => void;
}

const MoreWorks: React.FC<Props> = ({
  list = [],
  onClickItem,
  onClickMore
}) => {

  return (
    <div className={s.wrap}>
      <div className={s.title}>Ta的更多作品</div>
      <div className={s.list}>
        {
          list.slice(0, 5).map(item => (
            <div 
              key={item.id} 
              className={s.item}
              onClick={() => onClickItem(item.id)}
            >
              <div className={s.left}>
                <img src={item.imgUrl} alt="" />
              </div>
              <div className={s.right}>
                <div className={s.workName}>{item.title || '此作品未命名'}</div>
                <div>
                  <span className={s.number}>
                    <span className={`${s.icon} ${s.eye}`}></span>
                    {num2likestr(item.browseNum)}
                  </span>
                  <span className={s.number}>
                    <span className={`${s.icon} ${s.like}`}></span>
                    {num2likestr(item.likeNum)}
                  </span>
                </div>
              </div>
            </div>
          ))
        }
      </div>
      <div className={s.handle} onClick={onClickMore}>
        <ArrowRight text="查看更多" />
      </div>
    </div>
  )
}
export default MoreWorks;